<template>
  <div class="container">

    <heading-one class="-margin-md">メンテナンス中</heading-one>

    <section>
      <p>ただいまシステムメンテナンス中です。<br>
        終了次第、サービスを再開いたしますので、いましばらくお待ちください。<br>
        ご迷惑をおかけし誠に申し訳ございませんが、ご理解のほどよろしくお願い申しあげます。<br>
        ※メンテナンス時間につきましては、au PAY スマートローントップの「重要なお知らせ」をご覧ください。
      </p>
    </section>

    <btngroup-single class="-margin-lg">
      <btn-main class="-main -md" routerName="sv001">
        au PAY スマートローントップへ
      </btn-main>
    </btngroup-single>

  </div>
</template>

<script>
import HeadingOne from '../components/heading/HeadingOne'
import BtngroupSingle from '../components/button/BtngroupSingle'
import BtnMain from '../components/button/BtnMain'
export default {
  name: 'Tem-031',
  metaInfo: {
    title: 'メンテナンス中',
    meta: [
      {name: 'description', content: ''},
      {name: 'keywords', content: ''}
    ]
  },
  components: {
    BtnMain,
    BtngroupSingle,
    HeadingOne
  },
  data () {
    return {
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Tem031.vue